import React from 'react';
import styles from './communication-center.module.scss';
import { CommunicationCompose } from './components/communication-compose';
import classNames from 'classnames';
import { List, ScreenTitle } from 'src/components/design-system';
import { useSearchParams } from 'react-router-dom';
import { CommunicationSentItems } from './components/communication-sent-items';

const ACTIONS = {
  COMPOSE_MESSAGE: 'compose-message',
  SENT_MESSAGES: 'sent-messages',
};

export function CommunicationCenterPageComponent({ lang, ...props }) {
  const [queryParams, setQueryParams] = useSearchParams();
  const selected = queryParams.get('action');
  const [activeAction, setActiveAction] = React.useState(selected || ACTIONS.COMPOSE_MESSAGE);

  const onItemSelected = React.useCallback(
    id => {
      setActiveAction(id);
      setQueryParams({ action: id });
    },
    [setQueryParams],
  );

  const [actions, rendering] = React.useMemo(() => {
    const rendering = {
      [ACTIONS.COMPOSE_MESSAGE]: <CommunicationCompose {...props} lang={lang} />,
      [ACTIONS.SENT_MESSAGES]: <CommunicationSentItems />,
    };

    const actions = [
      {
        id: ACTIONS.COMPOSE_MESSAGE,
        name: lang.COMPOSE,
      },
      {
        id: ACTIONS.SENT_MESSAGES,
        name: lang.SENT_MESSAGES,
      },
    ];

    return [actions, rendering];
  }, [lang, props]);

  return (
    <div className={classNames('new-design-system', styles.root)}>
      <div className={styles.header}>
        <ScreenTitle title={lang.HEADER} />
      </div>
      <div className={styles.mainScreen}>
        <div className={styles.list}>
          <List
            dataSource={actions}
            selected={activeAction}
            labelTextProperty="name"
            onItemSelected={onItemSelected}
          />
        </div>
        <div className={styles.content}>{rendering[activeAction]}</div>
      </div>
    </div>
  );
}
